import { locale as agentBox } from '@agents/components/agent-box/i18n/en';
import {locale as changeAgentDialog } from '@agents/components/change-agent-dialog/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...agentBox.data,
        ...changeAgentDialog.data,
    }
};